import React, { useEffect } from "react";

import { useTracking } from "react-tracking";

const NavbarIconsGroupConcern = () => {
  
  const { trackEvent } = useTracking();

  useEffect(() => {
    
    trackEvent({ component: "ListGroupConcern", event: "ListGroup-Clicked" });
  }, []);

  return <div className="d-flex justify-content-end gradient-custom-sky custom-nav-height"></div>;
};

export default NavbarIconsGroupConcern;
